import React from "react";

import {
  usePrivacyContext,
} from "../context/PrivacyContext";


import {
  PrivacyPreferencesButton,
} from "./PrivacyPreferencesButton";





interface LegalLinksProps {


  privacyPolicyUrl?: string;


  cookiePolicyUrl?: string;


  className?: string;


}





export function LegalLinks({


  privacyPolicyUrl,


  cookiePolicyUrl,


  className = "",


}: LegalLinksProps){



  const {

    translations,

  } =
    usePrivacyContext();






  return (



    <nav

      className={`privacy-legal-links ${className}`}

    >





      {


        privacyPolicyUrl && (



          <a

            href={privacyPolicyUrl}

          >


            {translations.privacyPolicy}


          </a>



        )

      }







      {


        cookiePolicyUrl && (



          <a

            href={cookiePolicyUrl}

          >


            {translations.cookiePolicy}


          </a>



        )

      }







      <PrivacyPreferencesButton />





    </nav>



  );

}